import React, { useEffect, useState } from 'react';
import api from '../api';
import { Plus, Trash2, Edit3, Save, X, Shield, User as UserIcon } from 'lucide-react';

export default function Users() {
  const [users, setUsers]     = useState([]);
  const [domains, setDomains] = useState([]);
  const [show, setShow]       = useState(false);
  const [editing, setEditing] = useState(null);
  const [error, setError]     = useState('');

  const load = async () => {
    try {
      const [u, d] = await Promise.all([api.get('/users'), api.get('/domains')]);
      setUsers(u.data); setDomains(d.data);
    } catch (e) { setError(e.response?.data?.error || 'Erro ao carregar'); }
  };
  useEffect(() => { load(); }, []);

  const del = async (u) => {
    if (!window.confirm(`Excluir o usuário ${u.username}?`)) return;
    try { await api.delete(`/users/${u.id}`); load(); }
    catch (e) { alert(e.response?.data?.error || 'Erro'); }
  };

  if (error) return <p className="err-msg">{error}</p>;

  return (
    <>
      <div className="page-title">
        <h1>Usuários do Painel</h1>
        <button onClick={() => setShow(true)}><Plus size={14}/> Novo Usuário</button>
      </div>

      <table>
        <thead>
          <tr>
            <th>Usuário</th>
            <th>E-mail</th>
            <th>Papel</th>
            <th>Domínios acessíveis</th>
            <th>Criado</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td><strong>{u.username}</strong></td>
              <td style={{color:'#a1a1aa'}}>{u.email || '–'}</td>
              <td>
                {u.role === 'admin'
                  ? <span className="badge ok"><Shield size={10} style={{verticalAlign:'middle'}}/> admin (total)</span>
                  : <span className="badge warn"><UserIcon size={10} style={{verticalAlign:'middle'}}/> user</span>}
              </td>
              <td style={{fontSize:'.82rem'}}>
                {u.role === 'admin'
                  ? <span style={{color:'#a1a1aa'}}>todos</span>
                  : (u.domains.length
                      ? u.domains.map(d => <span key={d.id} className="badge ok" style={{marginRight:'.3rem'}}>{d.name}</span>)
                      : <span style={{color:'#a1a1aa'}}>nenhum</span>)}
              </td>
              <td style={{color:'#a1a1aa'}}>{new Date(u.created_at).toLocaleString('pt-BR')}</td>
              <td>
                <button className="secondary" onClick={() => setEditing(u)}><Edit3 size={12}/></button>{' '}
                <button className="danger" onClick={() => del(u)}><Trash2 size={12}/></button>
              </td>
            </tr>
          ))}
          {!users.length && <tr><td colSpan={6} style={{color:'#a1a1aa'}}>Nenhum usuário.</td></tr>}
        </tbody>
      </table>

      {show && <UserModal domains={domains} onClose={() => { setShow(false); load(); }} />}
      {editing && <UserModal user={editing} domains={domains} onClose={() => { setEditing(null); load(); }} />}
    </>
  );
}

function UserModal({ user, domains, onClose }) {
  const editing = !!user;
  const [form, setForm] = useState({
    username: user?.username || '',
    password: '',
    email: user?.email || '',
    role: user?.role || 'user',
    domainIds: user?.domains?.map(d => d.id) || [],
  });
  const [msg, setMsg] = useState('');

  const toggleDomain = (id) => {
    setForm(f => ({
      ...f,
      domainIds: f.domainIds.includes(id) ? f.domainIds.filter(x => x !== id) : [...f.domainIds, id]
    }));
  };

  const save = async () => {
    setMsg('');
    try {
      if (editing) {
        const body = {
          role: form.role,
          email: form.email,
          domainIds: form.role === 'admin' ? [] : form.domainIds,
        };
        if (form.password) body.password = form.password;
        await api.put(`/users/${user.id}`, body);
      } else {
        if (!form.username || !form.password) { setMsg('Username e senha obrigatórios'); return; }
        await api.post('/users', {
          username: form.username,
          password: form.password,
          email: form.email || null,
          role: form.role,
          domainIds: form.role === 'admin' ? [] : form.domainIds,
        });
      }
      onClose();
    } catch (e) {
      setMsg(e.response?.data?.error || 'Erro');
    }
  };

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{minWidth: '560px'}}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          <h2 style={{margin:0}}>{editing ? `Editar — ${user.username}` : 'Novo Usuário'}</h2>
          <button className="ghost" onClick={onClose}><X size={16}/></button>
        </div>

        {!editing && (
          <>
            <label>Username</label>
            <input value={form.username} onChange={e => setForm({...form, username: e.target.value})}
              placeholder="raphael" />
          </>
        )}

        <label>{editing ? 'Nova senha (vazio = manter)' : 'Senha'}</label>
        <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} />

        <label>E-mail (opcional)</label>
        <input value={form.email} onChange={e => setForm({...form, email: e.target.value})}
          placeholder="contato@exemplo.com" />

        <label>Papel</label>
        <div style={{display:'flex', gap:'.6rem', marginTop:'.2rem'}}>
          <label style={{display:'flex', alignItems:'center', gap:'.4rem', flex:1, padding:'.6rem', border:'1px solid ' + (form.role==='admin'?'#3b82f6':'#27272a'), borderRadius:'6px', cursor:'pointer'}}>
            <input type="radio" style={{width:'auto'}} checked={form.role==='admin'} onChange={() => setForm({...form, role: 'admin'})} />
            <Shield size={14}/> <strong>Administrador</strong>
            <span style={{color:'#a1a1aa', fontSize:'.78rem'}}>(acesso total)</span>
          </label>
          <label style={{display:'flex', alignItems:'center', gap:'.4rem', flex:1, padding:'.6rem', border:'1px solid ' + (form.role==='user'?'#3b82f6':'#27272a'), borderRadius:'6px', cursor:'pointer'}}>
            <input type="radio" style={{width:'auto'}} checked={form.role==='user'} onChange={() => setForm({...form, role: 'user'})} />
            <UserIcon size={14}/> <strong>Usuário</strong>
            <span style={{color:'#a1a1aa', fontSize:'.78rem'}}>(só domínios selecionados)</span>
          </label>
        </div>

        {form.role === 'user' && (
          <>
            <label>Domínios acessíveis</label>
            <div style={{maxHeight:'250px', overflow:'auto', border:'1px solid #27272a', borderRadius:'6px', padding:'.5rem'}}>
              {domains.length === 0 && <p style={{color:'#a1a1aa', margin:0}}>Nenhum domínio cadastrado.</p>}
              {domains.map(d => (
                <label key={d.id} style={{display:'flex', alignItems:'center', gap:'.4rem', padding:'.3rem 0', cursor:'pointer'}}>
                  <input type="checkbox" style={{width:'auto'}}
                    checked={form.domainIds.includes(d.id)}
                    onChange={() => toggleDomain(d.id)} />
                  <strong>{d.name}</strong>
                  <span style={{color:'#a1a1aa', fontSize:'.78rem'}}>{d.ipv4}</span>
                </label>
              ))}
            </div>
            <p style={{color:'#a1a1aa', fontSize:'.78rem', marginTop:'.3rem'}}>
              {form.domainIds.length} domínio(s) selecionado(s).
              Usuário poderá gerenciar zonas, e-mail, webmail, Nginx e reverso desses domínios.
            </p>
          </>
        )}

        {msg && <div className="err-msg">{msg}</div>}

        <div className="modal-actions">
          <button className="secondary" onClick={onClose}>Cancelar</button>
          <button onClick={save}><Save size={12}/> {editing ? 'Salvar' : 'Criar'}</button>
        </div>
      </div>
    </div>
  );
}
